/**
 * Opens chat pop up with form
 *
 * @author Lennart van Welzen
 */
window.chat_popup = function() {
    var self = this;
    var $body                           = $('body')
    var $open_chat_popup_button         = $('.js-open-chat-popup-button');
    var $close_chat_popup_button        = $('.js-close-chat-popup-button')
    var $chat_popup                     = $('.js-chat-popup');
    var $webchat_form                   = $('.js-webchat-form');
    var $errors                         = $('.js-error');
    var $inputs                         = $('.c-input-text');
    var is_browser_safari               = false;

    self.init = function( browser ) {

        //Event listener for opening popup
        $open_chat_popup_button.on('click', function(){
            $chat_popup.addClass('is-open');

            if(window.innerWidth < 960) {
                //Disable scrolling when popup is open
                $body.addClass('u-disable-scroll');
            }
        });

        //Event listener for closing popup
        $close_chat_popup_button.on('click', function(){
            $chat_popup.removeClass('is-open');

            if(window.innerWidth < 960) {
                //Enable scrolling when popup is closed
                $body.removeClass('u-disable-scroll');
            }
        });

        //Event listener to check if body has disable scroll class
        window.addEventListener('resize', () => {
            if(window.innerWidth < 960){
                if(!$body.hasClass('u-disable-scroll')){
                    $body.addClass('u-disable-scroll')
                }
            } else {
                if($body.hasClass('u-disable-scroll')){
                    $body.removeClass('u-disable-scroll')
                }
            }
        });

        // If browser is safari, set var
        if( browser === 'Safari' ){
            is_browser_safari = true;
        }

        //Event listener for submitting webchat form
        $webchat_form.on('submit', self.submitForm);

        //Event listener for all text inputs
        $inputs.on('input', self.checkInputValue);
    };

    /**
     * Method for when the form has been submitted
     *
     * @author Dennis Bruinen <dennis@click.nl>
     * @param  Event e
     * @return void
     */
    self.submitForm = function(e) {
        e.preventDefault();
        $contact_popup_error = $(this).parents().find('.js-contact-popup-error');

        // Get the form data
        var form_data = new FormData( $(this)[0] );

        // Do an asynchronous call to check the filled in form data
        $.ajax({
            type: 'POST',
            url: $(this).attr('action'),
            data: form_data,
            cache: false,
            contentType: false,
            processData: false,
            async: false,
            success: self.formOnSuccess,
            error: self.formOnError
        });

    }

    /**
    * When the form has been submitted succesfully
    *
    * @author Dennis Bruinen <dennis@click.nl>
    * @param  Response data
    * @return void
    */
    self.formOnSuccess = function(data) {
        // Reset error fields
        // $errors.html('');
        // $contact_popup_error.empty();

        // Determine webchat url
        // TODO :: We need a webchat url for HEB (HEB-51)
        var webchat_url = 'https://www.timeforstorm.eu/IM/endpoint/guest/124/Vraag%20Loogman/0e92b51a77c224e11df1222b9a95dc84764b45330d59e3958b69e7b3425d72f0';
        webchat_url = webchat_url + '?name='+data.data.name+'&subject='+data.data.subject+'&email='+data.data.email;
        // Send user to webchat, if user is in Safari, open url in same tab (Safari doesn't play nice with new generated tabs)
        if( is_browser_safari ){
            window.location.assign(webchat_url);
        }else{
            window.open(webchat_url, '_blank');
        }
        alert(data.data.name + " " + data.data.subject + " " + data.data.email)
    };

    /**
    * When the form has an error, show the error below each field
    *
    * @author Dennis Bruinen <dennis@click.nl>
    * @param  Response error
    * @return void
    */
    self.formOnError = function(error) {
        // Reset error fields
        $errors.html('');
        $contact_popup_error.empty();
        // Iterate through errors
        var errors = [];
        if(error.responseJSON) {
            errors = error.responseJSON.errors;
        }
        // Iterate through every error
        for(let error in errors) {
            // Iterate through every array element in error
            for(var i = 0; i < errors[error].length; i++) {
                // find generic contact error div
                if(error == 'contact_popup_error'){
                    $contact_popup_error.html(errors[error][i]);
                }
                // Show the errors
                $webchat_form.find('[name="'+error+'"]').parent().parent().find('.js-error').text(errors[error][i]);
                $webchat_form.find('[name="'+error+'"]').parent().parent().find('.js-error').addClass('is-error white');
            }
        }
    };


    /**
     * Method to check if input values != empty. When value != empty it adds a "valid" class to the element target.
     * The "valid" class contains styling != empty input fields.
     *
     * @author Lennart van Welzen <lennart@click.nl>
     * @param  Event e
     * @return void
     */
    self.checkInputValue = function(e) {
        var element = $(e.target)
        if(e.target.value === ''){
            element.removeClass('valid')
        } else {
            element.addClass('valid')
        }
    }
};


// WEBPACK FOOTER //
// ./resources/assets/js/frontend/components/chat-popup.js